import styled from "styled-components";
import { resolvePaletteRoleForegroundToken } from "../../../functions/resolvePaletteRoleForegroundToken";

import {
	INPUT_BORDER_SIZE,
	INPUT_HEIGHT,
} from "../TextInputContainer/TextInputContainer.styles";

import { StyledTextAreaProps } from "./TextArea.types";

export const StyledTextArea = styled.textarea<StyledTextAreaProps>`
	margin-top: ${({ hasLabel, theme }) => (hasLabel ? theme.space["sm"] : 0)};
	border: ${INPUT_BORDER_SIZE} solid transparent;
	background: transparent;
	min-height: ${INPUT_HEIGHT};
	width: 100%;
	padding: ${({ theme }) => theme.space.md};
	left: 0;
	z-index: 1;
	color: ${({ colorOn, theme }) =>
		theme.palette.hexFor(resolvePaletteRoleForegroundToken(colorOn, 1))};
	resize: vertical;
	box-sizing: border-box;

	:focus {
		outline: none;
	}

	:focus + .Label {
		transform: translateY(-50%);
	}

	${({ hasValue }) => {
		return {
			...(hasValue && {
				" + .Label": {
					transform: "translateY(-50%)",
				},
			}),
		};
	}}
`;
